// extracted by mini-css-extract-plugin
export default {"container":"documentitem_container__VXVUM","documentIco":"documentitem_documentIco__Zt6Qf","title":"documentitem_title__Xca4Z"};